import * as React from 'react'

import { useUsageAndCostLabelsMap } from '../../../hooks/useUsageAndCostLabelsMap/useUsageAndCostLabelsMap'
import { Surface } from '../../common'
import { UsageCostRequestParams, UsageCostResponseBody } from '../../../hooks'
import { UsageAndCostChart } from '@/features/Analytics/components/UsageAndCostChart/UsageAndCostChart'

interface UsageAndCostChartContainerProps {
    data: UsageCostResponseBody
    showSummaryDropdown?: boolean
    dataSets: string[]
    filters: UsageCostRequestParams
    totalUsns: number
}

export const UsageAndCostChartContainer: React.FC<
    UsageAndCostChartContainerProps
> = ({ data, showSummaryDropdown, dataSets, filters, totalUsns }) => {
    const labelsMap = useUsageAndCostLabelsMap(filters, true)

    return (
        <Surface className="h-full min-w-minWidgetWidth">
            <UsageAndCostChart
                showSummaryDropdown={showSummaryDropdown}
                data={data}
                labelsMap={labelsMap}
                dataSets={dataSets}
                totalUsns={totalUsns}
            />
        </Surface>
    )
}
